import type { JsonSchemaType, UserGroup } from '@gmn-portal/backend';
import { useIntl } from '@/core/i18n/use-intl';
import { MetadataBuilderWithPreview } from '@/shared/components/metadata/metadata-builder/metadata-builder-with-preview';
import { Button, Dialog, DialogContent, DialogFooter } from '@/shared/components/ui';

type ContractMetadataBuilderDialogProps = {
  open: boolean;
  value: JsonSchemaType | undefined;
  onChange: (schema: JsonSchemaType | undefined) => void;
  onCancel: () => void;
  onSave: () => void;
  userGroups?: UserGroup[];
};

export function ContractMetadataBuilderDialog({
  open,
  value,
  onChange,
  onCancel,
  onSave,
  userGroups,
}: ContractMetadataBuilderDialogProps) {
  const { t } = useIntl();
  const contractMetadataDefaultUpdateGroupKeys = ['dgzrs-billing'];

  return (
    <Dialog open={open} onOpenChange={(next) => !next && onCancel()}>
      <DialogContent
        className="!max-w-[90vw] !w-[1400px] max-h-[90vh] overflow-hidden flex flex-col p-0 gap-0"
        showCloseButton={false}
      >
        <div className="flex-1 overflow-hidden">
          <div className="h-[70vh]">
            <MetadataBuilderWithPreview
              value={value}
              onChange={onChange}
              userGroups={userGroups}
              defaultUpdateGroupKeys={contractMetadataDefaultUpdateGroupKeys}
              header={false}
              storageKey="gmn.metadataBuilder.contractDialog.formPreview.open"
            />
          </div>
        </div>
        <DialogFooter className="border-t p-5">
          <Button type="button" variant="outline" onClick={onCancel}>
            {t('common.cancel')}
          </Button>
          <Button type="button" onClick={onSave}>
            {t('common.save')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
